import { Controller } from "@hotwired/stimulus"

// Displays a live character counter beneath a text input or textarea.
// Usage:
//   data-controller="char-count"
//   data-char-count-max-value="100"
//   data-char-count-warn-value="80"      (optional, default 80 % of max)
//   data-char-count-input-target on the <input> or <textarea>
//   data-char-count-display-target on the <span> that shows "n / max"

export default class extends Controller {
  static targets = ["input", "display"]
  static values = { max: Number, warn: Number }

  connect() {
    this.#update()
  }

  // Called via data-action="input->char-count#count"
  count() {
    this.#update()
  }

  #update() {
    if (!this.hasInputTarget || !this.hasDisplayTarget) return

    const len = this.inputTarget.value.length
    const max = this.maxValue || 0

    if (max > 0) {
      this.displayTarget.textContent = `${len} / ${max}`
      const warnAt = this.hasWarnValue ? this.warnValue : Math.floor(max * 0.8)
      this.displayTarget.classList.toggle("warn", len >= warnAt && len <= max)
      this.displayTarget.classList.toggle("over", len > max)
    } else {
      this.displayTarget.textContent = `${len}`
    }
  }
}
